import React from 'react';

import { StyledTextArea } from './styles';

function TextArea({ disabled, ...props }) {
  return <StyledTextArea disabled={disabled} {...props} />;
}

export default TextArea;
